export function camelToUnderscore(str) {
  return str?.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function underscoreToCamel(str) {
  return str?.replace(/(_[a-z])/g, (s) => s.toUpperCase()?.replace("_", ""));
}

export function ucFirst(str) {
  if (!str) {
    return str;
  }
  return str[0].toUpperCase() + str.slice(1);
}
